import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TableLayout } from '../../containers/Layout';
import {
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Box,
  TableFooter,
  Typography,
} from '@material-ui/core';
import SingleTransferTemplate from '../singleTemplates/SingleTransferTemplate';
import Currency from '../../../../../commonModules/Currency';
import { fetchTransferDetails } from '../../../../../../../../jsx/actions/transferAction';
import { isEmpty } from 'lodash-es';
import { toast } from 'react-toastify';
import { useCurrency } from '../../../../../../../../jsx/hooks/useCurrency';
import { generateTransferPDF } from '../../../../../../../../jsx/utils/transferPDFGenerator';
import SingleBL from '../../reapproIntern/SingleBL';

const SingleTransferAvoir = (props) => {
    const currency = useCurrency();
    const dispatch = useDispatch();
	const PRODUCTS = useSelector((state) => state.inventory.products); 

    const [trsf, setTrsf] = useState({});
    const [BL, setBL] = useState(false);
    const [TVA, setTVA] = useState(true);

    useEffect(() => {
        const fetchTransferData = async () => {
            try {
                const data = await dispatch(fetchTransferDetails(props.transfer.id, "avoir"));
                setTrsf(data);
            } catch (error) {
                console.error('Error fetching transfer details:', error);
            }
        };
    
        fetchTransferData();
    }, [dispatch, props.transfer.id]);

    const createProductList = () => {
        console.log('====================================');
        console.log({trsf});
        console.log('====================================');
        return !isEmpty(trsf) && trsf.products.map((avoirItem) => {
            let prod = PRODUCTS && PRODUCTS[avoirItem.product_id];
            // Use values directly from backend (correctly saved)
            let totalHT = parseFloat(avoirItem.total_ht || avoirItem.price_ht || 0);
            let totalTTC = parseFloat(avoirItem.total_ttc || avoirItem.price_ttc || 0);
            let tvaRate = avoirItem.tva_rate || 0;  // Use saved tva_rate (0 if exempt), don't fallback to product
            
            // Only recalculate if tvaRate > 0 AND totalTTC equals totalHT (incorrect data)
            // If tvaRate is 0 (VAT exempt), totalTTC should equal totalHT (correct)
            if (tvaRate !== 0 && totalTTC === totalHT) {
                totalTTC = totalHT * (1 + tvaRate / 100);
            }
            
            let PUHT = totalHT / avoirItem.quantity;

            return (
                <TableRow key={avoirItem.id}>
                    <TableCell className="photo-trsf-single">
                        {prod && prod.photos && prod.photos.length > 0 && prod.photos[0].filename &&
                            <img 
                                id={prod.photos[0].filename} 
                                src={`/stocks/photos/${prod.photos[0].filename}`} 
                                // style={{width:"100px", height:"auto"}}
                            />
                        }
                    </TableCell>
                    <TableCell className="text-left">{prod?.name || `Product ID: ${avoirItem.product_id}`}</TableCell>
                    <TableCell className="text-right">{avoirItem.quantity}</TableCell>
                    <TableCell className="text-right"><Currency value={PUHT} /></TableCell>
                    <TableCell className="text-right"><Currency value={totalHT} /></TableCell>
                    {TVA &&
                        <>
                            <TableCell className="text-right">{tvaRate} %</TableCell>
                            <TableCell className="text-right"><Currency value={totalTTC} /></TableCell>
                        </>
                    }
                </TableRow>
            );
        });
    };

    const calculateTotals = () => {
        let totalHT = 0;
        let totalTTC = 0;
        const aibAmount = parseFloat(trsf.aib || 0) || 0;
        const productList = Array.isArray(trsf.products) ? trsf.products : [];

        productList.forEach((avoirItem) => {
            let itemHT = parseFloat(avoirItem.total_ht || avoirItem.price_ht || 0);
            let itemTTC = parseFloat(avoirItem.total_ttc || avoirItem.price_ttc || 0);
            let tvaRate = avoirItem.tva_rate || 0;

            if (tvaRate !== 0 && itemTTC === itemHT) {
                itemTTC = itemHT * (1 + tvaRate / 100);
            }

            totalHT += itemHT || 0;
            totalTTC += itemTTC || 0;
        });

        return {
            totalHT,
            totalTTC,
            aib: aibAmount,
            totalToPay: totalTTC + aibAmount,
        };
    };

    const totals = calculateTotals();

    const downloadInvoicePDF = async () => {
        if (!trsf.intern_ref_id && !trsf.id) {
            toast.error('⚠️ Numéro d\'avoir manquant!');
            return;
        }
        try {
            await generateTransferPDF({
                transferDetails: trsf,
                shop: props.shop,
                client: props.client || {},
                products: PRODUCTS || {},
                options: { showTVA: TVA, currency: currency || 'FCFA' },
                onSuccess: () => toast.success('PDF téléchargé avec succès!'),
                onError: (err) => {
                    toast.error(`Erreur lors du téléchargement PDF: ${err.message}`);
                },
            });
        } catch (err) {
            if (!err.message?.includes('required')) {
                toast.error(`Erreur lors du téléchargement PDF: ${err.message}`);
            }
        }
    };

    return (
        <SingleTransferTemplate
            shop={props.shop}
            client={props.client}
            shopDest={props.shopDest}
            avoir={trsf}
            transfer={trsf}
            agent={props.agent}
            notif={props.notif}
            handleBL={() => setBL(!BL)}
            downloadInvoicePDF={downloadInvoicePDF}
            BL={BL}
            BLOpt
            TVA={TVA}
            TVAOpt
            handleCheck={() => setTVA(!TVA)}
        >
        {BL ?
            <SingleBL
                PRODUCTS={PRODUCTS}
                transfer={trsf}
            />
        :
            <TableLayout>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell className="text-left">Produit</TableCell>
                        <TableCell>Quantité</TableCell>
                        <TableCell>PU HT</TableCell>
                        <TableCell>Total HT</TableCell>
                        {TVA &&
                            <>
                                <TableCell>TVA</TableCell>
                                <TableCell>Total TTC</TableCell>
                            </>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {createProductList()}
                    <TableRow>
                    <TableCell colSpan={9}></TableCell>
                    </TableRow>
                </TableBody>

                <TableFooter>
                    <TableRow>
                    <TableCell colSpan={3}></TableCell>
                    <TableCell style={{ textAlign: "right" }}>
                        <Typography variant="h6">Total Produits</Typography>
                    </TableCell>
                    <TableCell className="f-700">
                        <Typography variant="h6"><b><Currency value={totals.totalHT} /></b></Typography>
                    </TableCell>
                    {TVA &&
                        <>
                        <TableCell></TableCell>
                        <TableCell>
                            <Typography variant="h6"><b><Currency value={totals.totalTTC} /></b></Typography>
                        </TableCell>
                        </>
                    }
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={3}></TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                            <Typography variant="h6">AIB/BIC</Typography>
                        </TableCell>
                        <TableCell className="f-700">
                            <Typography variant="h6"><b><Currency value={totals.aib} /></b></Typography>
                        </TableCell>
                        {TVA &&
                            <>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                            </>
                        }
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={3}></TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                            <Typography variant="h6">Total Avoir</Typography>
                        </TableCell>
                        {TVA ? (
                            <>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell>
                                    <Typography variant="h6"><b><Currency value={totals.totalToPay} /></b></Typography>
                                </TableCell>
                            </>
                        ) : (
                            <TableCell className="f-700">
                                <Typography variant="h6"><b><Currency value={totals.totalToPay} /></b></Typography>
                            </TableCell>
                        )}
                    </TableRow>
                </TableFooter>
            </TableLayout>
        }
        </SingleTransferTemplate>
    );
};

export default SingleTransferAvoir;
